import Vue from 'vue';
import { DeviceInfo } from '@/shared/libs';

if (!DeviceInfo.isSupported()) {
  window.location.href = '/old-browser';
}

Vue.config.productionTip = false;
Vue.config.errorHandler = (err, vm) => {
  if (!vm) {
    window.location.href = '/error';
  }

  console.error(err); // eslint-disable-line
};
